import * as yup from 'yup'

export const schemaCreateSupplierModal = yup.object().shape({
    partner_name: yup.string().required('partner-name-required'),
    partner_code: yup.string().nullable(),
    partner_email: yup.string().email('invalid-email').nullable(),
    partner_phone: yup.string().nullable(),
    partner_address: yup.string().nullable(),
    partner_tax_code: yup.string().required('partner-tax-code-required'),
    partner_representative: yup.string().nullable(),
    partner_representative_phone: yup.string().nullable(),
    partner_bank_account: yup.string().nullable(),
    partner_bank_name: yup.string().nullable(),
    partner_note: yup.string().nullable(),
    partner_status: yup
        .string()
        .oneOf(['active', 'inactive', 'suspended'])
        .default('active'),
})
